import type { LensCalendar } from '~/types/leLens';

import type { LensDateRange } from './cardView';
import { LENS_DEFAULT_CALENDAR, dayLabel, spanLabel } from './lensCalendar';

export const resolvedPeriodConvention = (calendar: LensCalendar = LENS_DEFAULT_CALENDAR): string =>
  `Windows are decided in ${calendar.zone}`;

/** The window a period resolves to, as the server writes one: `18–24 Sep`, `26 Aug – 24 Sep`. */
export function formatResolvedPeriod(range: LensDateRange): string {
  const { from, to } = range;
  if (!from && !to) {
    return 'Every available date';
  }
  if (from && to) {
    return spanLabel(from, to);
  }
  return from ? `From ${dayLabel(from)}` : `To ${dayLabel(to)}`;
}
